import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 */
export class UrlPublishDraftValueObject extends ValueObject {
  /**
   * @param {Object}  data
   * @param {String} data.code
   * @param {String} data.url
   */
}
